import { z } from 'zod';

export type UpdateUserPayload = z.infer<typeof updateUserPayloadSchema>;

export const updateUserPayloadSchema = z.object({
  enabled: z.boolean().optional(),
});
